import { useLDClient } from 'launchdarkly-react-client-sdk';
import { Member, User } from '@quick/client';

export const useIdentifyLaunchdarkly = () => {
  const client = useLDClient();
  return async (user: User, member: Member | undefined) => {
    client?.identify({
      key: user.userId.toString(),
      email: user.email || member?.email,
      name: member?.name,
      custom: filterNonNull({
        userId: member?.userId,
        memberId: member?.memberId,
        memberEmail: member?.email,
        communityId: member?.communityId,
      }),
    });
  };
};

const filterNonNull = (record: {
  [key: string]: string | boolean | number | Array<string | boolean | number> | undefined;
}): {
  [key: string]: string | boolean | number | Array<string | boolean | number>;
} => {
  Object.keys(record).forEach((key) => (record[key] === undefined ? delete record[key] : {}));
  // @ts-ignore
  return record;
};

export const useResetLaunchdarkly = () => {
  const client = useLDClient();
  return async () => {
    client?.identify({ anonymous: true });
  };
};
